/**
 * Redux selectors for polygon state
 */
import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@app/store";

export const selectPolygons = (state: RootState) => state.survey.polygons || [];

export const selectCurrentPolygonId = (state: RootState) =>
  state.survey.currentPolygonId;

export const selectIsPolygonDrawingMode = (state: RootState) =>
  state.survey.isPolygonDrawingMode || false;

export const selectVisiblePolygons = createSelector(
  [selectPolygons],
  (polygons) => polygons.filter((p) => !p.isHidden),
);

export const selectCurrentPolygon = createSelector(
  [selectPolygons, selectCurrentPolygonId],
  (polygons, currentId) => {
    if (!currentId) return null;
    return polygons.find((p) => p.polygonId === currentId) || null;
  },
);

export const selectPolygonCount = createSelector(
  [selectPolygons],
  (polygons) => polygons.length,
);

export const selectVisiblePolygonCount = createSelector(
  [selectVisiblePolygons],
  (polygons) => polygons.length,
);
